<template>
  <div class="flex-col p-md gap-md card-background border-radius-">
    <dd-card v-for="(object, key) in singleLevelMessage" :key="key">
      <h3>{{ key }}</h3>
      <dd-card-stacked-list :list="object"></dd-card-stacked-list>
    </dd-card>
  </div>
</template>

<script>
import { toCurrency, toDate, toPercentage } from "~/plugins/string-helpers";
import { DateFormatEnum } from "~/enums";

export default {
  props: {
    message: {
      type: Object,
    },
  },
  methods: {
    addSpaces(key) {
      // 1. Insert a space between a block of uppercase letters and an uppercase letter followed by a lowercase letter.
      //    e.g. "NAWData" -> "NAW Data"
      const step1 = key.replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2");

      // 2. Insert a space between a lowercase letter/digit and an uppercase letter.
      //    e.g. "PartijNAWData" -> "Partij NAW Data"
      //         "VoorNamen" -> "Voor Namen"
      const result = step1.replace(/([a-z\d])([A-Z])/g, "$1 $2");

      return result;
    },
    formatData(key, data) {
      // If the key ends with "Dt", format the data as a date.
      if (key.includes("Dt")) {
        return toDate(data, DateFormatEnum.DISPLAY_DATE);
      }

      // If the key ends with "Bedrag" or "Ruimte", or contains "Saldo", format as currency.
      if (
        key.includes("Bedrag") ||
        key.includes("Ruimte") ||
        key.includes("Waarde") ||
        key.includes("Inschrijving") ||
        key.includes("Saldo")
      ) {
        return toCurrency(data, 2);
      }

      // If the key ends with "Pct", format as a percentage.
      if (key.includes("Pct")) {
        return toPercentage(parseFloat(data), 2);
      }

      // Otherwise, return the original data.
      return data;
    },
  },
  computed: {
    singleLevelMessage() {
      let inputObject = this.message;

      let output = {};

      let recursiveFormat = (key, object) => {
        let formattedObject = {};
        let todo = [];

        if (typeof object === "object") {
          Object.entries(object).forEach(([dkey, data]) => {
            if (Array.isArray(data)) {
              data.forEach((data, index) => {
                todo.push({
                  key: `${key} - ${dkey} - ${index}`,
                  data: data,
                });
              });
            } else if (typeof data === "object" && dkey !== "@attributes") {
              todo.push({
                key: `${key} - ${dkey}`,
                data: data,
              });
            } else if (typeof data === "string" && dkey !== "@attributes") {
              formattedObject[this.addSpaces(dkey)] = this.formatData(dkey, data);
            }
          });
        } else {
          formattedObject[this.addSpaces(key)] = this.formatData(key,object);
        }


        let values = Object.values(formattedObject);
        if (values.length > 1 || (values.length === 1 && values[0])) {
          output[this.addSpaces(key)] = formattedObject;
        }

        todo.forEach(({ key, data }) => {
          recursiveFormat(key, data);
        });
      };

      Object.entries(inputObject).forEach(([key, data]) =>
        recursiveFormat(key, data)
      );

      return output;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/_default.scss";

.card-background {
  background-color: $main-content-bg-color;
}
</style>
